import "@blocknote/mantine/style.css";

import { useEffect } from "react";

import "@/styles/textEditorStyles.css";
import ButtonHelp from "../ui/ButtonHelp";

import { useUiStore } from "@/stores/UiStore";
import Editor from "@/features/proposal/editor/Editor";
import StreamingEditor from "@/features/proposal/editor/StreamingEditor";
import { useGetStreamingStatus } from "@/features/proposal/editor/useGetStreamingStatus";
import { useParams } from "react-router-dom";
import DocumentSkeleton from "@/ui/DocumentSkeleton";
import { useGetPursuitDocsFromProposal } from "@/features/pursuit/useGetPursuitDocsFromProposal";

const steps = [
  {
    title: "AI chat ",
    content: <div>Click to chat with our AI</div>,
    target: "#gp-chat",
    placement: "bottom-end",
    disableBeacon: true,
  },
  {
    title: "Download document",
    content: "Download the proposal as a word document",
    target: "#gp-download",
    placement: "bottom-end",
    disableBeacon: true,
  },
];

function ProposalGenerator() {
  const { proposal_id, searchType } = useParams();
  const { data, isLoading } = useGetStreamingStatus(proposal_id, searchType);
  const { data: docIds, isLoading: isLoadingPursuit } =
    useGetPursuitDocsFromProposal(searchType, proposal_id);
  useEffect(() => {
    useUiStore.setState({
      sidebarExpanded: false,
    });
  }, []);
  if (isLoading || isLoadingPursuit) {
    return <DocumentSkeleton />;
  }
  return (
    <>
      {data ? (
        <StreamingEditor
          streamingStatus={data}
          proposal_id={proposal_id}
          searchType={searchType}
        />
      ) : (
        <Editor
          proposal_id={proposal_id}
          searchType={searchType}
          docIds={docIds?.map((doc) => doc.openai_id) || undefined}
        />
      )}
      <ButtonHelp steps={steps} />
    </>
  );
}

export default ProposalGenerator;
